// extracted by mini-css-extract-plugin
export var featuredImageHeight = "40vh";
export var navbarHeight = "50rem";
export var maxFooterHeight = "64rem";
export var brandDropdown = "NavBrandContents-module--brand-dropdown--YBuD9";
export var openDropdown = "NavBrandContents-module--open-dropdown--2DLVC";